import { render, staticRenderFns } from "./ComunaView.vue?vue&type=template&id=fd28e730&scoped=true"
import script from "./ComunaView.vue?vue&type=script&lang=js"
export * from "./ComunaView.vue?vue&type=script&lang=js"
import style0 from "./ComunaView.vue?vue&type=style&index=0&id=fd28e730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd28e730",
  null
  
)

export default component.exports